import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminArchive from "@/pages/admin/AdminArchive";
import AdminCellar from "@/pages/admin/AdminCellar";
import ArchiveEntryPage from "@/pages/ArchiveEntryPage";
import FolioPreview from "@/pages/FolioPreview";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center">
        <div className="font-mono text-[10px] tracking-widest2 uppercase text-cream/50">Verifying…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/folio" element={<FolioPreview />} />
              <Route path="/archive/:id" element={<ArchiveEntryPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="submissions" element={<AdminSubmissions />} />
                <Route path="archive" element={<AdminArchive />} />
                <Route path="cellar" element={<AdminCellar />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0E1A16",
                color: "#EFE6D6",
                border: "1px solid rgba(176,141,87,0.5)",
                borderRadius: 0,
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
